module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "min-width": "1020px !important"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "xlabel-width": "50px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "xstyle": "margin:0",
      "label": "Site :"
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Site"
    },
    on: {
      "change": _vm.filterReports
    },
    model: {
      value: (_vm.sitecode),
      callback: function($$v) {
        _vm.sitecode = $$v
      },
      expression: "sitecode"
    }
  }, _vm._l((_vm.codes.sites), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code + ' - ' + item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Report"
    },
    model: {
      value: (_vm.reportsel),
      callback: function($$v) {
        _vm.reportsel = $$v
      },
      expression: "reportsel"
    }
  }, _vm._l((_vm.selectviews), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code + ' - ' + item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Period"
    },
    on: {
      "change": _vm.checkPeriode
    },
    model: {
      value: (_vm.periodsel),
      callback: function($$v) {
        _vm.periodsel = $$v
      },
      expression: "periodsel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "( Manual Period )",
      "value": "man"
    }
  }), _vm._v(" "), _vm._l((_vm.codes.periods), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Output"
    },
    model: {
      value: (_vm.output),
      callback: function($$v) {
        _vm.output = $$v
      },
      expression: "output"
    }
  }, _vm._l((_vm.outtypes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.manType),
      callback: function($$v) {
        _vm.manType = $$v
      },
      expression: "manType"
    }
  }, [_vm._v("Select Type ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.reportsel == '',
      "type": _vm.buttonType,
      "icon": "el-icon-open",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.showReport();
      }
    }
  }, [_vm._v("Open")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(this.periodsel == 'man') ? _c('span', [_c('el-form-item', {
    attrs: {
      "label": "Period:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin": "0",
      "width": "120px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.periodFrom),
      callback: function($$v) {
        _vm.periodFrom = $$v
      },
      expression: "periodFrom"
    }
  }, _vm._l((_vm.codes.manPeriods), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Till:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.periodTill),
      callback: function($$v) {
        _vm.periodTill = $$v
      },
      expression: "periodTill"
    }
  }, _vm._l((_vm.codes.manPeriods), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.manType) ? _c('span', [_c('el-form-item', {
    attrs: {
      "label": "Type :"
    }
  }, [_c('el-select', {
    staticStyle: {
      "min-width": "575px",
      "x": "500px"
    },
    attrs: {
      "multiple": "",
      "size": "mini",
      "Placeholder": "Status"
    },
    model: {
      value: (_vm.bookStatSel),
      callback: function($$v) {
        _vm.bookStatSel = $$v
      },
      expression: "bookStatSel"
    }
  }, _vm._l((_vm.codes.bookstatus), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1)], 1) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "padding": "0 10px",
      "line-height": "1.5em",
      "font-size": "12px",
      "border": "1px solid #ccc",
      "height": "600px",
      "overflow": "auto"
    },
    attrs: {
      "id": "area"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.reportdata))])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [(_vm.reportLoaded) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "icon": "el-icon-download",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.download();
      }
    }
  }, [_vm._v("Download " + _vm._s(_vm.lastType) + " as File")]) : _vm._e(), _vm._v(" "), (_vm.reportLoaded && this.lastType != 'TABLE') ? _c('el-checkbox', {
    staticStyle: {
      "margin-left": "20px"
    },
    model: {
      value: (_vm.openApp),
      callback: function($$v) {
        _vm.openApp = $$v
      },
      expression: "openApp"
    }
  }, [_vm._v("Open App")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f8a9a37"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/report.vue
// module id = 641
// module chunks = 1